import useChangeLogQuery from '@hooks/fetchChangeLog';

const ChangeLogFetcher = () => {
  useChangeLogQuery();  // Initiates the query but doesn't render anything
  return null;  // This component does not render anything
};

export default ChangeLogFetcher;
